import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Dialog from "@material-ui/core/Dialog"
import Slide from "@material-ui/core/Slide"
import DialogContent from "@material-ui/core/DialogContent"
import RoundedClose from "../../images/close.png"
import "./index.scss"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import SearchIcon from "../../images/search-icon.png"
import Checkmark from "../../images/checkmark.png"
import { Divider } from "../divider"
import { AppButton } from "../button"
import { connect } from "react-redux"
import { APPLY_FILTERS, HIDE_COOKIES } from "../../state/constants"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const FiltersModal = connect(state => state.app.productFilters)(({ open, onClose, pathContext, data, allIngredients, dispatch, ...props }) => {


  const getModalStaticData = data &&
    data.prismic &&
    data.prismic.allOur_chocolate_pages &&
    data.prismic.allOur_chocolate_pages.edges[0] &&
    data.prismic.allOur_chocolate_pages.edges[0].node

  const isDesktop = useMediaQuery("(min-width:600px)")

  const getShapes = () => {
    return data && data.prismic && data.prismic.allChocolate_shapes && data.prismic.allChocolate_shapes.edges
  }

  const getTypes = () => {
    return data && data.prismic && data.prismic.allChocolate_types && data.prismic.allChocolate_types.edges
  }

  const [selectedIngredients, setSelectedIngredients] = useState(props.ingredients)
  const [selectedTypes, setSelectedTypes] = useState(props.types)
  const [selectedShapes, setSelectedShapes] = useState(props.shapes)
  const [searchText, setSearchText] = useState("")

  useEffect(() => {
    if (open) {
      setSelectedIngredients(props.ingredients)
      setSelectedTypes(props.types)
      setSelectedShapes(props.shapes)
    }
  }, [open])

  const [active, setActive] = useState("")
  // console.log(active)

  const onClickIngredient = (ingredient) => {
    let newSelected = [...selectedIngredients]
    if (newSelected.indexOf(ingredient) === -1) {
      newSelected.push(ingredient)
    } else {
      newSelected = newSelected.filter(i => i !== ingredient)
    }
    setSelectedIngredients(newSelected)
    // console.log("onClickIngredient " + ingredient + " filtered: " + props.ingredients)
  }

  const onClickType = (type) => {
    // console.log("onClickType", type)
    let newSelected = [...selectedTypes]
    if (newSelected.indexOf(type) === -1) {
      newSelected.push(type)
    } else {
      newSelected = newSelected.filter(i => i !== type)
    }
    setSelectedTypes(newSelected)
  }

  const onClickShape = (shape) => {
    // console.log("onClickShape", shape)
    let newSelected = [...selectedShapes]
    if (newSelected.indexOf(shape) === -1) {
      newSelected.push(shape)
    } else {
      newSelected = newSelected.filter(i => i !== shape)
    }
    setSelectedShapes(newSelected)
  }

  const applyFilters = () => {
    dispatch({
      type: APPLY_FILTERS,
      productFilters: {
        ingredients: selectedIngredients,
        shapes: selectedShapes,
        types: selectedTypes,
        search: ""
      }
    })
    onClose()
  }

  const applySearch = () => {
    dispatch({
      type: APPLY_FILTERS,
      productFilters: {
        ingredients: [],
        shapes: [],
        types: [],
        search: searchText
      }
    })
    setSearchText("")
    onClose()
  }

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
      <DialogContent className="app-filters-modal">
        <div className="app-filters-modal-content">
          <div className="container text-center modal-content-wrapper py-sm-5">
            <div className="d-flex justify-content-end">
              <button className="close-button" onClick={onClose}>
                <img src={RoundedClose} alt="close-modal"/>
              </button>
            </div>
            <form className="subscribe-form my-4 mx-auto">
              <input
                className="subscribe-input"
                type="text"
                placeholder={getModalStaticData.search_field_placeholder}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault()
                    applySearch()
                  }
                }}/>
              <button type="submit" className="subscribe-submit" style={{ width: !searchText.length ? "25px" : "70px" }}>{!searchText.length ?
                <img className="mail-icon" src={SearchIcon}/> :
                <div className="search-button" onClick={(e) => {
                  e.preventDefault()
                  applySearch()
                }}>{getModalStaticData.search_field_button_text}</div>}</button>
            </form>
            <div className="actual-filters">
              <div className="">
                {getTypes() &&
                <div className="row chocolate-types-container">
                  {getTypes().map((type, index) =>
                    <div key={index.toString()} className="col position-relative choco-type-col" onClick={() => onClickType(type.node.name)}>
                      {!!selectedTypes.find(i => i === type.node.name) &&
                      <img className="img-fluid position-absolute" src={Checkmark}/>
                      }
                      <img className="img-fluid chocolate-type-image" src={type.node?.image?.url}/>
                      <p className="chocolate-type-name">{type?.node?.name}</p>
                    </div>
                  )}
                </div>
                }
                <Divider/>
              </div>
              <div>
                {getShapes() &&
                <div className="row chocolate-shapes-container">
                  {getShapes().map((shape, index) =>
                    <div key={index.toString()} className="col choco-shape-col" onClick={() => onClickShape(shape?.node?.name)}>
                      {!!selectedShapes.find(i => i === shape?.node?.name) &&
                      <img className="img-fluid position-absolute" src={Checkmark} width="20"/>
                      }
                      <img className="img-fluid chocolate-shape-image" src={shape.node?.image?.url}/>
                      <p className="chocolate-shape-name pt-2">{shape?.node?.name}</p>
                    </div>
                  )}
                </div>
                }
                <Divider/>
              </div>
              <div>
                {allIngredients &&
                <div>
                  <div className="row ingredients-container d-flex d-md-none">
                    {allIngredients.map((ing, index) =>
                      <div className="col-6 text-left pr-1" key={index.toString()}>
                        <label className="d-block">
                          <input type="checkbox" id={ing} name={ing} checked={!!selectedIngredients.find(i => i === ing)} onChange={() => {
                            onClickIngredient(ing)
                          }}/>
                          <span className="checkbox-label position-relative d-flex text-left">{ing}</span>
                        </label>
                      </div>
                    )}
                  </div>
                  <div className={"row ingredients-container d-none d-md-flex " + (props.pageContext.lang === 'de-at' ? "pl-md-5" : "")}>
                    {allIngredients.map((ing, index) =>
                      <div className={"text-left " + (props.pageContext.lang === 'de-at' ? "col-6" : "col-4 pr-1")} key={index.toString()}>
                        <label className="d-block">
                          <input type="checkbox" id={ing} name={ing} checked={!!selectedIngredients.find(i => i === ing)} onChange={() => {
                            onClickIngredient(ing)
                          }}/>
                          <span className="checkbox-label position-relative d-flex">{ing}</span>
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                }
              </div>
              <div className="py-4 my-sm-4" onClick={applyFilters}>
                <AppButton>{getModalStaticData.apply_filters_button_text}</AppButton>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
})

FiltersModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}
